import { useState, useEffect } from 'react';
import { useMutationData } from "@hooks/useMutationData";
import queryKeys from '@configs/react-query/query-key';

const useSystemInfo = () => {
  const [systemInfo, setSystemInfo] = useState({
    version: "1.0.0",
    licenseLeftDays: 1735,
    licenseMaxUsers: 100
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getAboutInfo = useMutationData(
    queryKeys.aboutInfo,
    {
      method: "GET",
    },
    {
      onSuccess: (response) => {
        setSystemInfo(response);
      },
      onError: (error) => {
        console.error("Error during get about info: ", error);
      },
    },
  );

  const fetchSystemInfo = async () => {
    setLoading(true);
    setError(null);
    
    try {
      getAboutInfo.mutate();
    } catch (err) {
      setError(err.message);
      console.error('Failed to fetch system info:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSystemInfo();
  }, []);

  return {
    systemInfo,
    loading,
    error,
    refetch: fetchSystemInfo
  };
};

export default useSystemInfo;
